export const splitPhone = (phoneValue) => {
  if (!phoneValue || typeof phoneValue !== "string") {
    return { countryCode: null, phoneNumber: null };
  }

  const match = phoneValue.match(/^(\+\d{1,4})(.*)$/);
  if (!match) {
    const fallback = phoneValue.match(/^(\+\d+)(.*)$/);
    if (!fallback)
      return { countryCode: null, phoneNumber: phoneValue || null };
    return {
      countryCode: fallback[1],
      phoneNumber: (fallback[2] || "").trim() || null,
    };
  }

  return {
    countryCode: match[1] || null,
    phoneNumber: (match[2] || "").trim() || null,
  };
};

export const normalizeValue = (val) => {
  if (val === "") return null;
  if (val === undefined) return null;
  return val;
};
